import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { isTrackCodeInternalUser } from "common/trackcodeInternal";
import { resolveActiveLogisticCompanyId } from "features/app/components/logisticCompanySwitcherUtils";
import { fetchWorkspaces } from "./CollaborationService";
import CollaborationHeader, {
  navigateCollaborationAfterTenantSwitch
} from "./components/CollaborationHeader";
import CollaborationContentLoading from "./components/CollaborationContentLoading";
import { resolveCollaborationEmptyState, resolveCollaborationIndexView } from "./collaborationUtils";
import {
  didCollaborationTenantContextChange,
  shouldFetchCollaborationData
} from "./collaborationTenantChange";

class CollaborationListing extends Component {
  static propTypes = {
    user: PropTypes.object,
    logisticCompanyId: PropTypes.number,
    logisticCompanyPrepareChange: PropTypes.bool
  };

  state = {
    workspaces: [],
    loading: true,
    error: null
  };

  componentDidMount() {
    if (shouldFetchCollaborationData(this.props)) {
      this.loadWorkspaces();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      didCollaborationTenantContextChange(prevProps, this.props) &&
      shouldFetchCollaborationData(this.props)
    ) {
      this.loadWorkspaces();
    }
  }

  loadWorkspaces = async () => {
    this.setState({ loading: true, error: null });

    try {
      const workspaces = await fetchWorkspaces();
      this.setState({ workspaces, loading: false });
    } catch (error) {
      this.setState({ loading: false, error: "Workspaces konnten nicht geladen werden." });
    }
  };

  render() {
    const { user, logisticCompanyId } = this.props;
    const { workspaces, loading, error } = this.state;
    const isInternalUser = isTrackCodeInternalUser(user);
    const activeLogisticCompanyId = resolveActiveLogisticCompanyId(
      logisticCompanyId,
      user
    );

    const view = !loading && !error
      ? resolveCollaborationIndexView({ isInternalUser, workspaces })
      : null;

    if (view?.type === "redirect") {
      return <Redirect to={`/collaboration/${view.slug}`} />;
    }

    let content = null;

    if (loading) {
      content = <CollaborationContentLoading />;
    } else if (error) {
      content = (
        <EmptyState>
          <EmptyTitle>Fehler beim Laden</EmptyTitle>
          <EmptyMessage>{error}</EmptyMessage>
        </EmptyState>
      );
    } else if (view.type === "empty") {
      const emptyState = resolveCollaborationEmptyState({
        isInternalUser,
        activeLogisticCompanyId
      });

      content = (
        <EmptyState>
          <EmptyTitle>{emptyState.title}</EmptyTitle>
          <EmptyMessage>{emptyState.message}</EmptyMessage>
        </EmptyState>
      );
    } else {
      content = (
        <EmptyState>
          <EmptyTitle>Mehrere Workspaces gefunden</EmptyTitle>
          <EmptyMessage>
            Für diesen Mandanten sind mehrere Workspaces hinterlegt. Bitte wenden
            Sie sich an Ihren TrackCode-Ansprechpartner.
          </EmptyMessage>
        </EmptyState>
      );
    }

    return (
      <Page>
        <CollaborationHeader onAfterSwitch={navigateCollaborationAfterTenantSwitch} />
        <ContentBody>{content}</ContentBody>
      </Page>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth?.user,
  logisticCompanyId: state.auth?.logisticCompanyId,
  logisticCompanyPrepareChange: state.auth?.logisticCompanyPrepareChange
});

export default connect(mapStateToProps)(CollaborationListing);

const Page = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f7f6f2;
  overflow: auto;
`;

const ContentBody = styled.div`
  flex: 1;
  padding: 24px 32px 32px;
  max-width: 960px;
`;

const EmptyState = styled.section`
  max-width: 520px;
  margin: 48px auto 0;
  text-align: center;
`;

const EmptyTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #181714;
`;

const EmptyMessage = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #6a6960;
`;
